module.exports = __webpack_public_path__ + "scotland.svg?42cea563795b180d834f91a65481c465";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/scotland.svg
// module id = 286
// module chunks = 10